import o from "./CompletionSurvey.js";
import { h as e } from "../../helpers-BWRnlsd3.mjs";
const i = {
  CompletionSurvey: o,
  helpers: e
};
export {
  i as default
};
